export default __webpack_public_path__ + "locales/sr-Cyrl-RS/ChangeUserStatusDialog.json?hash=db2bc6c4766e9ca818746de8b9f5c9ad";